import { BaseEntity } from "../../core";



export class Deductible extends BaseEntity {
    public policiy: number;
    public claim: number;
    public complaint: number;
    public instance: string;
    public docket: string;
    public paymentClass: string;
    public beneficiary: string;
    public paymentDate: Date;
    public paymentDateString: string;
    public balance: number;
    public codeInsured: number;
    public name: string;
    public complaintDateString: string;
    public plate: string;
    public type: string;
    public commitmentBalance: number;
    public Commitment: number;

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/model/deductible.ts